/* eslint-disable */
export default {
  Home: '住宅',
  Mobile: '手机',
  Work: '公司',
} as const;

// @key: @#@"Home"@#@ @source: @#@"Home"@#@
// @key: @#@"Mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"Work"@#@ @source: @#@"Work"@#@
